import React, { createContext, useContext, useState, useCallback } from 'react';

interface LoadingContextType {
  isSystemLoading: boolean;
  loadingMessage: string;
  setSystemLoading: (loading: boolean, message?: string) => void;
}

const LoadingContext = createContext<LoadingContextType | undefined>(undefined);

export const LoadingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isSystemLoading, setIsSystemLoading] = useState<boolean>(false);
  const [loadingMessage, setLoadingMessage] = useState<string>('');

  const setSystemLoading = useCallback((loading: boolean, message: string = '') => {
    setIsSystemLoading(loading);
    setLoadingMessage(message);
  }, []);

  return (
    <LoadingContext.Provider value={{ isSystemLoading, loadingMessage, setSystemLoading }}>
      {children}
    </LoadingContext.Provider>
  );
};

export const useSystemLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    return {
      isSystemLoading: false,
      loadingMessage: '',
      setSystemLoading: () => {},
    };
  }
  return context;
};
